module.exports = __webpack_public_path__ + "static/media/wisedb2.f248144b.png";